<!--Element多选树形控件-->
<template>
	<div class="el_Tree_Body" :style="bodyStyle">
		<div class="elTree_hideButton">
			<div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
			</div>
			<div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
			</div>
		</div>
		<transition name="el-zoom-in-center">
		<div v-show="isShow" class="elTree_body">
		<div style="display: flex;padding-top:15px;align-items: center;">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
		</div>
		<el-scrollbar style="height:95%;width: 100%;">
			<el-tree :data="data" :expand-on-click-node="false" show-checkbox node-key="pkid" :default-checked-keys="defaultDevice" :props="defaultProps" @check-change="nodeClick" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree">
				<span class="custom-tree-node" slot-scope="{node}">
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='Category'"/>
			 	<img src="../../../../public/static/image/elTree/camera.png" v-show="node.data.type=='camera'"/>
			 	<span style="padding-left: 5px;" v-show="node.data.type=='Category'">{{node.data.categoryName }}</span>
			 	<span style="padding-left: 5px;" v-show="node.data.type=='camera'">{{node.data.camera_name }}</span>
				</span>
			</el-tree>
		</el-scrollbar>
		</div>
	 </transition>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'next',
					label: 'label'
				},
				defaultDevice:[],
				isShow: true,
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
		},
		destroyed() {},
		computed: {
			bodyStyle() {
				let width = '0px'
				if(this.isShow) {
					width = '2.26rem'
				}
				return {
					"width": width
				}
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDeviceList(){
				return this.$store.deviceStore.state.nowVirtualDeviceList
			},
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				if(!isempty(nv)) {
					this.data = this.dataList
					this.defaultDevice=[this.dataList[0].next[0].pkid]
					this.$emit('checkItem',[this.dataList[0].next[0]])
				}
			},
		},
		methods: {
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick() {
				let list = this.$refs.tree.getCheckedNodes()
				this.$emit('checkItem',list)
			},
		}
	}
</script>

<style>
	.el_Tree_Body .el-checkbox__inner{
		border: 1px solid #797a7c;
	}
</style>